import AddButton from "../components/AddButton";
import Sidebar from "../components/Sidebar";
import RefreshButton from "../components/RefreshButton";
import React, {useEffect, useState} from "react";
import {privateApi} from "../api";
import axios from "axios";
import {toast} from "react-toastify";

type BrandResponse = {
    status: string;
    code: number;
    message: string;
    brands: Brand[];
}

type Brand = {
    id: string;
    name: string;
}

type DeviceResponse = {
    status: string;
    code: number;
    message: string;
    devices: DeviceObject[];
    total: number;
}

type DeviceObject = {
    id: string;
    model: string;
    brand: string;
    type: string;
}

type DeviceTypeResponse = {
    status: string;
    code: number;
    message: string;
    types: string[];
}
const PER_PAGE = 25;

function Device() {
    localStorage.setItem("focus", "dispositivi")
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    const [brandFilterId, setBrandFilterId] = React.useState("");
    const [brands, setBrands] = React.useState<Brand[]>([]);
    const [devices, setDevices] = React.useState<DeviceObject[]>([]);
    const [deviceTypes, setDeviceTypes] = React.useState<string[]>([]);

    const [selectedBrand, setSelectedBrand] = React.useState("");
    const [selectedDeviceType, setSelectedDeviceType] = React.useState("");
    const [deviceModel, setDeviceModel] = React.useState("");

    const [editSelectedDeviceId, setEditSelectedDeviceId] = React.useState("");
    const [editDeviceModel, setEditDeviceModel] = React.useState("");
    const [editSelectedDeviceType, setEditSelectedDeviceType] = React.useState("");
    const [editSelectedBrand, setEditSelectedBrand] = React.useState("");

    const [page, setPage] = React.useState(0);
    const [total, setTotal] = useState(0);
    const totalPages = Math.ceil(total / PER_PAGE);


    const resetForm = () => {

    }

    const loadDevices = async () => {
        setLoading(true);
        try {
            const response = await privateApi.get<DeviceResponse>(`/cr-order-manager/v1/device?brandId=${brandFilterId}&page=${page}&perPage=${PER_PAGE}`);
            setDevices(response.data.devices);
            setTotal(response.data.total);
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        } finally {
            setLoading(false);
        }
    }

    const loadBrands = async () => {
        try {
            const response = await privateApi.get<BrandResponse>("/cr-order-manager/v1/deviceBrand");
            setBrands(response.data.brands);
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        }
    }

    const loadDeviceTypes = async () => {
        try {
            const response = await privateApi.get<DeviceTypeResponse>('/cr-order-manager/v1/device/type');
            setDeviceTypes(response.data.types);
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        }
    }

    const handleDelete = async () => {
        try {
            await privateApi.delete(`/cr-order-manager/v1/device/${editSelectedDeviceId}`)
            setIsEditModalOpen(false);
            loadDevices();
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        }
    }

    const handleEdit = async () => {
        try {
            const payload = {
                deviceId: editSelectedDeviceId,
                brandId: editSelectedBrand,
                deviceType: editSelectedDeviceType,
                model: editDeviceModel
            };
            await privateApi.patch("/cr-order-manager/v1/device", payload);
            setIsEditModalOpen(false);
            loadDevices();
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        }
    }

    const handleSubmit = async () => {
        if (!selectedBrand) return toast.error("Seleziona un brand");
        if (!selectedDeviceType) return toast.error("Seleziona un tipo dispositivo");
        if (!deviceModel) return toast.error("Inserisci un modello");

        try {
            await privateApi.post("/cr-order-manager/v1/device", {
                model: deviceModel,
                brandId: selectedBrand,
                deviceType: selectedDeviceType
            });
            toast.success("Dispositivo creato con successo");
            setIsModalOpen(false);
            resetForm();
            loadDevices();
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        }
    }

    useEffect(() => {
        loadBrands();
        loadDeviceTypes();
    }, []);

    useEffect(() => {
        loadDevices();
    }, [brandFilterId, page]);

    return (
        <>
            <Sidebar/>
            <main className="ml-64 p-6">
                <div className="flex items-center justify-between mb-6">
                    <h1 className="text-2xl font-bold">Dispositivi</h1>
                    <div className="flex items-center gap-2">
                        <RefreshButton onClick={loadDevices}/>
                        <AddButton
                            onClick={() => {
                                resetForm();
                                setIsModalOpen(true);
                            }}
                        />
                    </div>
                </div>

                {/* FILTERS */}
                <div className="mb-6 bg-white p-4 rounded-xl shadow">
                    <div className="flex items-center justify-between">
                        <h2 className="font-semibold">Filtri</h2>
                    </div>

                    {/*FILTER HEADER */}
                    <div className="border-t pt-3 flex items-center justify-between mb-3">
                        {/*ORDER BY*/}
                        <div className="flex items-center gap-2">
                            <label className="text-sm text-gray-600">Brand:</label>
                            <select
                                value={brandFilterId}
                                onChange={(e) => {
                                    setBrandFilterId(e.target.value);
                                    setPage(0);
                                }}

                                className="border rounded px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-900">
                                <option key="" value="">-- Seleziona un brand --</option>
                                {brands.map((brand: Brand) => {
                                    return (<option key={brand.id} value={brand.id}>{brand.name}</option>)
                                })}
                            </select>
                        </div>
                    </div>
                </div>

                <div className="space-y-6">
                    <div className="bg-white rounded-xl shadow p-5">

                        {/*Table*/}
                        <div className="overflow-x-auto">
                            <table className="w-full text-sm text-left">

                                <thead className="text-gray-500 border-b">
                                <tr>
                                    <th className="py-2">ID</th>
                                    <th className="py-2">Modello</th>
                                    <th className="py-2">Brand</th>
                                    <th className="py-2">Tipo Dispositivo</th>
                                </tr>
                                </thead>

                                <tbody className="divide-y">
                                {loading ? (
                                    <tr>
                                        <td
                                            colSpan={4}
                                            className="py-6 text-center text-gray-500"
                                        >
                                            Caricamento...
                                        </td>
                                    </tr>
                                ) : devices.length === 0 ? (
                                    <tr>
                                        <td
                                            colSpan={4}
                                            className="py-6 text-center text-gray-500"
                                        >
                                            Nessun dispositivo trovato
                                        </td>
                                    </tr>
                                ) : (devices.map((device: DeviceObject) => (
                                    <tr key={device.id} className="hover:bg-gray-50"
                                        onClick={() => {
                                            setEditSelectedDeviceId(device.id);
                                            setEditSelectedBrand(brands.find(b => b.name === device.brand)?.id || "");
                                            setEditSelectedDeviceType(deviceTypes.find(d => d.toLowerCase() === device.type.toLowerCase()) || "");
                                            setEditDeviceModel(device.model);
                                            setIsEditModalOpen(true);
                                        }}>
                                        <td className="py-2">{device.id}</td>
                                        <td className="py-2">{device.model}</td>
                                        <td className="py-2">{device.brand}</td>
                                        <td className="py-2">{device.type}</td>
                                    </tr>
                                )))}

                                </tbody>

                            </table>
                        </div>

                        {/* PAGINATION */}
                        <div className="flex justify-between items-center mt-4">
                            <button
                                onClick={() => setPage((p) => Math.max(p - 1, 0))}
                                disabled={page === 0}
                                className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
                            >
                                Prev
                            </button>

                            <span className="text-sm">Pagina {page + 1} di {totalPages || 1}</span>

                            <button
                                onClick={() =>
                                    setPage((p) => Math.min(p + 1, totalPages - 1))
                                }
                                disabled={page >= totalPages - 1}
                                className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
                            >
                                Next
                            </button>
                        </div>

                    </div>
                </div>

                {isEditModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                        <div className="bg-white rounded-xl p-6 w-full max-w-md">
                            <h2 className="text-xl font-bold mb-4">
                                Modifica Dispositivo
                            </h2>

                            <div className="space-y-3">
                                <select className="w-full border p-2 rounded"
                                        value={editSelectedBrand}
                                        onChange={(e) => {
                                            setEditSelectedBrand(e.target.value);
                                        }}>
                                    <option key="" value="">-- Seleziona un brand --</option>
                                    {brands.map((brand: Brand) => {
                                        return (<option key={brand.id} value={brand.id}>{brand.name}</option>)
                                    })}
                                </select>
                                <select className="w-full border p-2 rounded"
                                        value={editSelectedDeviceType}
                                        onChange={(e) => {
                                            setEditSelectedDeviceType(e.target.value);
                                        }}>
                                    <option key="" value="">-- Seleziona un tipo dispositivo --</option>
                                    {deviceTypes.map((type: string) => {
                                        return (<option key={type} value={type}>{type}</option>)
                                    })}
                                </select>
                                <input className="w-full border p-2 rounded"
                                       placeholder="Modello*"
                                       value={editDeviceModel}
                                       onChange={(e) => {
                                           setEditDeviceModel(e.target.value);
                                       }}/>
                            </div>

                            <div className="flex justify-end gap-2 mt-4">
                                <button
                                    onClick={handleDelete}
                                    className="px-4 py-2 text-white bg-red-700 rounded"
                                >
                                    Elimina
                                </button>
                                <button
                                    onClick={() => {
                                        setIsEditModalOpen(false);
                                    }}
                                    className="px-4 py-2 bg-gray-200 rounded"
                                >
                                    Annulla
                                </button>

                                <button
                                    onClick={handleEdit}
                                    className="px-4 py-2 bg-blue-900 text-white rounded"
                                >
                                    Salva
                                </button>
                            </div>

                            <span>(*) Campo obbligatorio</span>
                        </div>
                    </div>
                )}

                {isModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                        <div className="bg-white rounded-xl p-6 w-full max-w-md">
                            <h2 className="text-xl font-bold mb-4">
                                Nuovo Dispositivo
                            </h2>

                            <div className="space-y-3">
                                <select className="w-full border p-2 rounded"
                                        value={selectedBrand}
                                        onChange={(e) => {
                                            setSelectedBrand(e.target.value);
                                        }}>
                                    <option key="" value="">-- Seleziona un brand --</option>
                                    {brands.map((brand: Brand) => {
                                        return (<option key={brand.id} value={brand.id}>{brand.name}</option>)
                                    })}
                                </select>
                                <select className="w-full border p-2 rounded"
                                        value={selectedDeviceType}
                                        onChange={(e) => {
                                            setSelectedDeviceType(e.target.value);
                                        }}>
                                    <option key="" value="">-- Seleziona un tipo dispositivo --</option>
                                    {deviceTypes.map((type: string) => {
                                        return (<option key={type} value={type}>{type}</option>)
                                    })}
                                </select>
                                <input className="w-full border p-2 rounded"
                                       placeholder="Modello*"
                                       value={deviceModel}
                                       onChange={(e) => {
                                           setDeviceModel(e.target.value);
                                       }}/>
                            </div>


                            <div className="flex justify-end gap-2 mt-4">
                                <button
                                    onClick={() => {
                                        setIsModalOpen(false);
                                        resetForm();
                                    }}
                                    className="px-4 py-2 bg-gray-200 rounded"
                                >
                                    Annulla
                                </button>

                                <button
                                    onClick={handleSubmit}
                                    className="px-4 py-2 bg-blue-900 text-white rounded"
                                >
                                    Salva
                                </button>
                            </div>

                            <span>(*) Campo obbligatorio</span>
                        </div>
                    </div>
                )}
            </main>
        </>
    )
}

export default Device;